import { useLocation } from 'react-router';
import { TabPills } from '@skupreme/shared/ui';
import {
  getStatusCounts,
  getStatusFromPath,
  getStatusTabItems,
  ORDER_STATUS_TABS,
  type StatusCountRow,
  V2_ORDER_STATUS_TABS,
} from '../../lib/status-tabs';
import { useOrdersV2 } from '../../hooks/orders-v2';

export type OrderStatusTabsProps = {
  /** Rows from the sidebar count call — one per status it has a figure for. */
  counts: StatusCountRow[] | undefined;
  className?: string;
};

export function OrderStatusTabs({ counts, className }: OrderStatusTabsProps) {
  const location = useLocation();
  const status = getStatusFromPath(location.pathname);
  /* EN-4403: the new orders page shows its four states; Held is a filter. */
  const { isV2 } = useOrdersV2();
  const tabs = isV2 ? V2_ORDER_STATUS_TABS : ORDER_STATUS_TABS;
  const items = getStatusTabItems(getStatusCounts(counts), tabs);

  /* Full counts, as in the prototype: 1,083, not 99+. */
  return (
    <TabPills
      label="Order status"
      items={items}
      selectedKey={status}
      className={className}
    />
  );
}
